import { ReactElement } from 'react';

import { css } from '@emotion/react';
import { ApiResponse } from '@type/web/api';
import { FraudLocalDetailResultType } from '@type/web/fraud';

import Icon from '@components/common/Icon/Icon';

import {
  gridItem,
  emphasizeText,
  infoButton,
} from '../fraudSearchResult.style';

interface ResultDetailBigDataProps {
  props: {
    handleToggle: (text?: string | undefined) => void;
    infoText: string;
    localDetail: ApiResponse<FraudLocalDetailResultType> | undefined;
  };
}

export default function ResultDetailBigData({
  props: { handleToggle, infoText, localDetail },
}: ResultDetailBigDataProps): ReactElement {
  const {
    data: { relatedKeywords },
  } = localDetail!;

  const bigDataList = [
    {
      title: '연관된 핸드폰 번호',
      count: relatedKeywords.phone_number || 0,
    },
    {
      title: '연관된 계좌번호',
      count: relatedKeywords.account_number || 0,
    },
    {
      title: '연관된 메신저ID',
      count: relatedKeywords.kakao_id || 0,
    },
  ];

  return (
    <div css={[gridItem, bigData]}>
      <button
        type="button"
        aria-label="analyze"
        css={infoButton}
        onClick={() => handleToggle(infoText)}
      >
        <Icon icon="info" />
      </button>
      <p className="title">빅데이터 분석</p>
      <ul>
        {bigDataList.map(({ title, count }) => (
          <BigDataList key={title} info={{ title, count }} />
        ))}
      </ul>
    </div>
  );
}

interface BigDataListProps {
  info: {
    title: string;
    count: number;
  };
}

function BigDataList({ info: { title, count } }: BigDataListProps) {
  return (
    <li>
      <p className="keyword">{title}</p>
      <p className="count">
        <span css={emphasizeText(true)}>{count}</span> 건
      </p>
    </li>
  );
}

const bigData = css`
  grid-column: 1/3;
  margin: 15px 0 8px 0;
  ul {
    margin: -10px 30px 10px 30px;
    li {
      font-size: 14px;
      padding: 10px;
      :not(:last-child) {
        border-bottom: 1px solid #e0e0e0;
      }
      display: flex;
      .keyword {
        font-weight: 500;
        text-align: center;
        flex: 1;
      }
      .count {
        flex: 1;
      }
    }
  }
`;
